/**
 * Neighbourhood card icons (P1D-5482 iteration 2).
 *
 * The badge that overlaps the bottom-left of each card's header image. Uploaded
 * to the same `neighbourhood-assets/` folder as the card header images, so they
 * are addressed through `config.IMAGE_STATIC_URL` like every other asset here.
 */

import config from "@Config/index";

const ICON_BASE = `${config.IMAGE_STATIC_URL}/neighbourhood-assets`;

/**
 * Optimization params for the badge icons. No `w`: the badge is small but the
 * source is not, and the icons looked soft rendered straight from the original.
 */
export const CARD_ICON_PARAMS = "?q=80&auto=format";

export type CardIcon = { src: string; width: number; height: number };

/**
 * Each icon carries its own box. They are square but for Cost of living, whose
 * artwork is wider than it is tall and looked squeezed at a square size.
 */
export const CARD_ICONS: Readonly<Record<string, CardIcon>> = Object.freeze({
  costOfLiving: {
    src: `${ICON_BASE}/Cost_of_living_icon.svg${CARD_ICON_PARAMS}`,
    width: 44,
    height: 32,
  },
  gettingAround: {
    src: `${ICON_BASE}/Getting_Around_icon.png${CARD_ICON_PARAMS}`,
    width: 36,
    height: 36,
  },
  safety: { src: `${ICON_BASE}/Safety_icon.png${CARD_ICON_PARAMS}`, width: 36, height: 36 },
  community: { src: `${ICON_BASE}/Community_icon.png${CARD_ICON_PARAMS}`, width: 36, height: 36 },
  climate: { src: `${ICON_BASE}/Climate_icon.png${CARD_ICON_PARAMS}`, width: 36, height: 36 },
});

export default CARD_ICONS;
